export class ResponseModel<T> {
  constructor(
    public status: number = 0,
    public data: T,
    public error?: object
  ) {}
}
